import { Box } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import MaterialTable, { MTableToolbar } from "material-table";
import React, { useEffect, useState } from "react";
import { getSuppliers } from "../../../Ancillary/SupplierManagement/helper/supplierManagementHelper";
import { getSessionData } from "../../../base/helper/baseHelper";
import Base from "../../../base/views/base";
import ConfirmationDialog from "../../../base/views/ConfirmationDialog";
import Popup from "../../../base/views/Popup";
import SelectableSearch from "../../../base/views/SelectableSearch";
import LandingPageFooter from "../../../LandingPage/views/LandingPageFooter";
import {
  addSaleableReturnsCurrent,
  addSaleableReturnsStage,
  deleteSaleableReturnsStage,
  editSaleableReturnsStage,
  getSaleableReturnsStage,
  UpdateCommentsSaleableReturn,
  GetCommentsSaleableReturn,
  truncateSaleableReturnStage,
} from "../helper/saleableReturnHelper";
import SaleableReturnForm from "./SaleableReturnForm";
import CommentPopup from "../../../base/views/CommentPopup";
import ChatIcon from "@material-ui/icons/Chat";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& .MuiPaper-root": {
      backgroundColor: "rgba(255,255,255,0.5)",
      backdropFilter: "blur(6px)",
      borderRadius: "15px",
      padding: "10px",
      marginTop: "1%",
      justifyContent: "center",
      alignItems: "center",
    },
  },
  container: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    marginBottom: theme.spacing(2),
    borderRadius: "5px",
    display: "flex",
    justifyContent: "space-between",
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(8px)",
  },
  formControl: {
    width: "20%",
  },
  form: {
    display: "flex",
    justifyContent: "space-between",
  },
  showpath: {
    padding: "0.5rem",
    marginRight: "1rem",
  },
  button: {
    marginRight: "1rem",
    borderRadius: "0.5rem",
  },
  reconsile: {
    display: "flex",
    justifyContent: "flex-end",
  },
}));

const initialStateValues = {
  selectedSupplier: { id: 0, optionname: "" },
  tote_number: "",
  ra_number: "",
  barcode: "",
};

function SaleableReturn(props) {
  const classes = useStyles();
  const [userId, setUserId] = useState("");
  const [storeId, setStoreId] = useState("");
  const [errors, setErrors] = React.useState({});
  const [supplierData, setSupplierData] = React.useState({
    load: false,
    values: [],
  });
  const [saleableReturnState, setSaleableReturnState] = useState(
    initialStateValues
  );
  const [gridData, setGridData] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [openCommentPopup, setOpenCommentPopup] = useState(false);
  const [openSaleableReturnDialog, setOpenSaleableReturnDialog] = useState(
    false
  );
  const [openDoubleConfirmDialog, setOpenDoubleConfirmDialog] = useState(false);
  const [openDuplicateRAPopup, setOpenDuplicateRAPopup] = useState(false);
  const [ndc, setNdc] = useState("");
  const [comment, setComment] = useState("");

  useEffect(() => {
    const store = JSON.parse(getSessionData({ key: "store" }));
    setUserId(getSessionData({ key: "userId" }));
    setStoreId(store.storeid);
    if (userId && storeId) {
      getSaleableReturnsStage({ storeId, userId }).then((response) => {
        setGridData(response);
        if (response.length > 0) {
          setOpenSaleableReturnDialog(true);
        }
      });
    }
  }, [userId, storeId]);

  const validateSA = (fieldValues = saleableReturnState) => {
    let temp = { ...errors };
    if ("selectedSupplier" in fieldValues) {
      temp.selectedSupplier =
        fieldValues.selectedSupplier.optionname === ""
          ? "Supplier is required"
          : "";
    }
    if ("tote_number" in fieldValues) {
      temp.tote_number =
        fieldValues.tote_number === "" ? "Tote # is required" : "";
    }
    if ("ra_number" in fieldValues) {
      temp.ra_number = fieldValues.ra_number === "" ? "RA # is required" : "";
    }
    setErrors({
      ...temp,
    });

    return Object.values(temp).every((x) => x === "");
  };

  const loadSupplierDropdown = () => {
    setSupplierData({ ...supplierData, load: true });
    getSuppliers(storeId)
      .then((response) => {
        let dropdownData = [];
        if (response.data.length)
          dropdownData = response.data.map((obj) => ({
            id: obj.supplier_id,
            optionname: obj.name,
          }));
        setSupplierData({ load: false, values: dropdownData });
      })
      .catch((err) => {});
  };

  const handleSupplierChange = (event, value) => {
    if (value && value.id) {
      setSaleableReturnState({
        ...saleableReturnState,
        selectedSupplier: { id: value.id, optionname: value.optionname },
      });
    } else {
      setSaleableReturnState({
        ...saleableReturnState,
        selectedSupplier: {},
      });
    }
  };

  const scan = (e, confirmRepeatRA = false) => {
    if (
      confirmRepeatRA || // Will come from explicit button action to add item
      (e.target.id === "barcode" && (e.type === "click" || e.which === 13))
    ) {
      addSaleableReturnsStage({
        storeId,
        userId,
        ...saleableReturnState,
        confirmRepeatRA,
      }).then((response) => {
        if (response.error) {
          if (
            response.error[0].message.toLowerCase() ===
            "this ra no. already exists"
          )
            setOpenDuplicateRAPopup(true);
          else setOpenDuplicateRAPopup(false);
        } else {
          setGridData(response);
          setSaleableReturnState({ ...saleableReturnState, barcode: "" });
          setOpenDuplicateRAPopup(false);
        }
      });
    }
  };

  const handleSASubmit = async (e) => {
    e.preventDefault();
    if (validateSA()) {
      addSaleableReturnsCurrent({
        storeId,
        userId,
        ...saleableReturnState,
      }).then((response) => {
        setSaleableReturnState(initialStateValues);
        setGridData([]);
      });
    }
  };

  const updateField = (e) => {
    setSaleableReturnState({
      ...saleableReturnState,
      [e.target.name]: e.target.value,
    });
  };

  const handleEdit = (updatedData) => {
    editSaleableReturnsStage(updatedData).then((response) =>
      setGridData(response)
    );
  };

  const handleDelete = () => {
    if (selectedItem)
      deleteSaleableReturnsStage({
        userId,
        storeId,
        ...selectedItem,
      }).then((response) => setGridData(response));
    setOpenDialog(false);
  };

  const addOrEdit = (resetForm) => {
    resetForm();
    setSelectedItem(null);
    setOpenPopup(false);
  };

  const handleCommentSubmit = () => {
    var data = {
      user_id: userId,
      store_id: storeId,
      ndc: ndc,
      comment: comment,
    };
    UpdateCommentsSaleableReturn(data)
      .then((response) => {
        setComment("");
        setOpenCommentPopup(false);
        setNdc("");
      })
      .catch((err) => {});
  };

  const getComments = (event, rowData) => {
    setNdc(rowData.ndc);
    GetCommentsSaleableReturn({
      user_id: userId,
      store_id: storeId,
      ndc: rowData.ndc,
    }).then((response) => {
      if (response && response.length > 0) {
        setComment(response[0].message);
      }
      setOpenCommentPopup(true);
    });
  };

  const enableDoubleConfirm = () => {
    setOpenDoubleConfirmDialog(true);
  };

  const onSaleableReturnOkButtonClick = () => {
    setOpenSaleableReturnDialog(false);
    setOpenDoubleConfirmDialog(false);
    var data = {
      user_id: userId,
      store_id: storeId,
    };
    truncateSaleableReturnStage(data)
      .then((response) => {
        setGridData([]);
        setSaleableReturnState({
          ...saleableReturnState,
          selectedSupplier: { id: 0, optionname: "" },
          tote_number: "",
          ra_number: "",
        });
      })
      .catch((err) => {});
  };

  const onSaleableReturnCancelClick = () => {
    setOpenSaleableReturnDialog(false);
    setOpenDoubleConfirmDialog(false);
    if (gridData && gridData.length > 0) {
      setSaleableReturnState({
        ...saleableReturnState,
        selectedSupplier: {
          id: parseInt(gridData[0].supplierid),
          optionname: gridData[0].supplier,
        },
        tote_number: gridData[0].toteno,
        ra_number: gridData[0].rano,
      });
    }
  };

  return (
    <div style={{ display: "flex" }}>
      <Base showBaseMenu={true} title="Saleable Returns">
        <Grid container spacing={2} style={{ marginTop: "2.5%" }}>
          <Grid item xs={12} sm={3}>
            {" "}
            <SelectableSearch
              autoFocus
              value={saleableReturnState.selectedSupplier}
              data={supplierData}
              name="supplier"
              label="Supplier"
              id="supplier"
              loading={loadSupplierDropdown}
              onChangeEvent={handleSupplierChange}
              variantType="standard"
              {...(errors.selectedSupplier && {
                error: true,
                helperText: errors.selectedSupplier,
              })}
            ></SelectableSearch>
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              value={saleableReturnState.ra_number}
              autoComplete="ra_number"
              name="ra_number"
              variant="standard"
              required
              fullWidth
              id="ra_number"
              label="Enter your RA number"
              className={classes.submit}
              onChange={updateField}
              {...(errors.ra_number && {
                error: true,
                helperText: errors.ra_number,
              })}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              value={saleableReturnState.tote_number}
              autoComplete="tote_number"
              name="tote_number"
              variant="standard"
              required
              fullWidth
              id="tote_number"
              label="Enter your TOTE number"
              className={classes.submit}
              onChange={updateField}
              {...(errors.tote_number && {
                error: true,
                helperText: errors.tote_number,
              })}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              value={saleableReturnState.barcode}
              autoComplete="barcode"
              name="barcode"
              variant="standard"
              required
              fullWidth
              id="barcode"
              label="Enter your Barcode"
              className={classes.submit}
              onKeyDown={scan}
              onChange={updateField}
            />
          </Grid>
        </Grid>
        <div className={classes.root}>
          <MaterialTable
            title={
              "Total Quantity: " +
              gridData?.reduce(
                (total, item) => total + item.quantity_by_ndc * 1,
                0
              )
            }
            columns={[
              { title: "Tote#", field: "toteno", defaultSort: "asc" },
              {
                title: "Supplier",
                field: "supplier",
                cellStyle: { width: "5%" },
              },
              {
                title: "RA#",
                field: "rano",
                defaultSort: "asc",
                cellStyle: { width: "5%" },
              },
              {
                title: "NDC/UPC",
                field: "ndc",
                defaultSort: "asc",
                cellStyle: { width: "15%" },
              },
              {
                title: "Description",
                field: "description",
                cellStyle: { width: "42%" },
              },
              {
                title: "Quatity by NDC",
                field: "quantity_by_ndc",
                cellStyle: { width: "13%" },
              },
            ]}
            data={gridData}
            actions={[
              {
                icon: "edit",
                tooltip: "Edit",
                position: "row",
                onClick: (event, rowData) => {
                  setOpenPopup(true);
                  setSelectedItem(rowData);
                },
              },
              {
                icon: "delete",
                tooltip: "Delete",
                position: "row",
                onClick: (event, rowData) => {
                  setOpenDialog(true);
                  setSelectedItem(rowData);
                },
              },
              {
                icon: () => <ChatIcon />,
                tooltip: "Comment",
                onClick: (event, rowData) => getComments(event, rowData),
                position: "row",
                // disabled: moduleAccess.editaccess === "Y" ? false : true,
              },
            ]}
            options={{
              rowStyle: (rowData) => {
                if (rowData.expiryflag === "1") {
                  return { backgroundColor: "#FFBF00" };
                } else if (rowData.expiryflag === "2") {
                  return { backgroundColor: "rgb(244, 67, 54)" };
                }

                return {};
              },
              maxBodyHeight: 670,
              paging: true,
              pageSize: 25,
              pageSizeOptions: [25, 50, 100],
              headerStyle: {
                backgroundColor: "rgba(255,255,255,1)",
                color: "black",
              },
            }}
            components={{
              Toolbar: (props) => (
                <Box display="flex">
                  <Box flexGrow={1}>
                    <MTableToolbar {...props} />
                  </Box>
                  <Box paddingBottom={1.5} paddingTop={2}>
                    <Button
                      onClick={(e) => {
                        handleSASubmit(e);
                      }}
                      fullWidth={true}
                      color="primary"
                      variant="contained"
                      size="medium"
                      style={{
                        backgroundColor: "rgb(22, 177, 255)",
                        borderRadius: "0.5rem",
                      }}
                    >
                      Submit to Reconcile
                    </Button>
                  </Box>
                </Box>
              ),
            }}
          />
        </div>
        <LandingPageFooter />
        <Popup
          title="Edit Saleable Return"
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
        >
          <SaleableReturnForm
            recordForEdit={{
              userId,
              storeId,
              suppliers: supplierData,
              ...selectedItem,
            }}
            addOrEdit={addOrEdit}
            editSaleableReturn={handleEdit}
          />
        </Popup>
        <CommentPopup
          title="Add Comments"
          openDialog={openCommentPopup}
          closeDialog={setOpenCommentPopup}
          comment={comment}
          onCommentChange={setComment}
          onSubmit={handleCommentSubmit}
          OkButtonText="Submit"
        />
        <ConfirmationDialog
          title="Do you want to proceed?"
          openDialog={openDialog}
          closeDialog={setOpenDialog}
          popupTitle="Stores"
          onSubmit={handleDelete}
        />
        <ConfirmationDialog
          title="A product with this RA no. already exists. Are you sure?"
          openDialog={openDuplicateRAPopup}
          closeDialog={() => setOpenDuplicateRAPopup(false)}
          popupTitle={"John"}
          OkButtonText={"Proceed"}
          onSubmit={(e) => scan(e, true)}
        />
        <ConfirmationDialog
          openDialog={openSaleableReturnDialog}
          closeDialog={setOpenSaleableReturnDialog}
          title="Can you please Confirm?"
          popupTitle="Capture Goods"
          onSubmit={enableDoubleConfirm}
          onCancel={onSaleableReturnCancelClick}
          CancelButtonText="Continue Scanning"
          OkButtonText="Create New session"
        />
        <ConfirmationDialog
          openDialog={openDoubleConfirmDialog}
          closeDialog={setOpenDoubleConfirmDialog}
          title="The scanned data will be deleted. Do you want to create new session?"
          popupTitle="Capture Goods"
          onSubmit={onSaleableReturnOkButtonClick}
          onCancel={onSaleableReturnCancelClick}
          CancelButtonText="No"
          OkButtonText="Yes"
        />
      </Base>
    </div>
  );
}

export default SaleableReturn;
